import React, { useEffect } from "react";
import LoadingSpinner from "components/LoadingSpinner";
import { connect } from "react-redux";
import { signOutAction } from "store/actions";

export const Logout = ({ signOut }) => {
  useEffect(() => {
    signOut();
  });
  return <LoadingSpinner text={"Logging you out..."} />;
};

const mapDispatchToProps = {
  signOut: signOutAction,
};

export default connect(null, mapDispatchToProps)(Logout);
